import { render, staticRenderFns } from "./SchematicItem.vue?vue&type=template&id=29f44a0c&lang=pug&"
import script from "./SchematicItem.vue?vue&type=script&lang=js&"
export * from "./SchematicItem.vue?vue&type=script&lang=js&"
import style0 from "./SchematicItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f44a0c')) {
      api.createRecord('29f44a0c', component.options)
    } else {
      api.reload('29f44a0c', component.options)
    }
    module.hot.accept("./SchematicItem.vue?vue&type=template&id=29f44a0c&lang=pug&", function () {
      api.rerender('29f44a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/SchematicItem.vue"
export default component.exports